<template>
  <v-row align="center">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon dark color="indigo" @click="download" v-on="on">
          <v-icon small>file_download</v-icon>
        </v-btn>
      </template>
      Download PDF
    </v-tooltip>
    <v-tooltip
      bottom
      v-if="$store.getters.hasAccessTo('itineraries:use_document_versioning')"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          dark
          color="orange darken-4"
          @click="onShowVersions"
          v-on="on"
        >
          <v-icon small>history</v-icon>
        </v-btn>
      </template>
      Versions
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon dark color="primary" @click="share" v-on="on">
          <v-icon small>share</v-icon>
        </v-btn>
      </template>
      Share
    </v-tooltip>
    <v-tooltip bottom v-if="!item.isAttachment">
      <template v-slot:activator="{ on }">
        <v-btn icon dark color="teal" @click="edit" v-on="on">
          <v-icon small>edit</v-icon>
        </v-btn>
      </template>
      Edit
    </v-tooltip>
    <confirmation-dialog
      @onConfirm="onRemoveAccept"
      v-if="
        (['D', 'V'].indexOf(item.documentType) > -1 || item.isAttachment) &&
        $store.getters.hasAccessTo('itineraries:delete_docs')
      "
    >
      <v-btn v-if="!removeVisible" icon small class="mx-0">
        <v-icon small color="pink">mdi-delete</v-icon>
      </v-btn>
      <template slot="message">{{ confirmationMessage }}</template>
    </confirmation-dialog>
  </v-row>
</template>
<script>
import ConfirmationDialog from "../shared/ConfirmationDialog.vue";
export default {
  components: { ConfirmationDialog },
  name: "ItineraryDocumentsListActions",
  props: {
    item: {
      default: {},
    },
  },
  data: () => ({
    fab: false,
    confirmationMessage: "Are you sure you want to delete this document?",
  }),

  computed: {
    removeVisible() {
      return false;
    },
  },
  methods: {
    edit() {
      this.fab = false;
      //this.$emit('rowAction',{data:this.item,action:'edit'});
      console.log(
        "edit",
        `${this.item.editURL}&uid=${this.$store.getters.userId}`
      );
      window.open(`${this.item.editURL}&uid=${this.$store.getters.userId}`);
    },
    onRemoveAccept() {
      this.$emit("rowAction", { ...this.item, action: "remove" });
    },
    download() {
      window.open(this.item.downloadURL);
    },
    share() {
      this.$emit("rowAction", { ...this.item });
    },
    onShowVersions() {
      this.$emit("rowAction", { ...this.item, action: "versions" });
    },
  },
};
</script>
<style scoped>
.align-center {
  bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/ItineraryDocumentsListActions.vue